export default {
  title: 'Technika',
  description: 'Tato stránka obsahuje přehled tachniky, kterou disponujeme.',
};
